import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { AppTitle } from '~/shared/ui/components/AppTitle'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import * as searchInitialModel from './model'

export function Title(): JSX.Element {
  return <AppTitle t='search' />
}

const skin = era.skin('routes/search/initial')

SearchPage.displayName = 'SearchPage'
export function SearchPage(): JSX.Element {
  const isContentLoading = useUnit(searchInitialModel.$contentLoading)
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper>
        <ui.RenderSkin name='stickySearchBlock' />
        <Skeleton pageType='grid' isLoading={isContentLoading}>
          <ui.RenderSkin name='recommendedVods' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
